import request from '@/utils/service'

export function getConfigs(data, locale) {
  return request({ url: 'config/list', data, locale })
}

export function updateConfig(data, locale) {
  return request({ url: 'config', data, locale })
}
